import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useDemoBooking } from "./DemoBookingDialog";

const PageShell = ({ title, mainClass, children }) => {
  const { pathname, hash, search } = useLocation();
  const navigate = useNavigate();
  const { openBooking } = useDemoBooking();

  useEffect(() => {
    document.title = title ? `${title} · Virpluz` : "Virpluz";
    const id = hash.replace("#", "");
    if (id === "book-demo") {
      openBooking();
      navigate({ pathname, search, hash: "" }, { replace: true });
      return;
    }
    const target = id ? document.getElementById(id) : null;
    if (target) {
      target.scrollIntoView();
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, search, title, navigate, openBooking]);

  return (
    <>
      <Navbar />
      <main id="main" className={mainClass}>
        {children}
      </main>
      <Footer />
    </>
  );
};

export default PageShell;
